import { componentFactory } from 'vue-tsx-support';

import { LazyHydrate } from '@jtnews/shared';

import { tsStoreMixin } from '../../../mixins';
import { injectStylesMixin } from '../../../mixins/inject-styles.mixin';
import { tagId } from '../../../utils/html.utils';

import styles from './adv-inread.styles.scss?module';

const THEMES_WITHOUT_ADS = [
  18304, 18535, 18538, 18703, 19339, 19779, 23627, 23630, 23633
];

type AdvData = {
  data: string;
  path: string;
  settings: {
    place: string;
    placeId: number;
    sticky: boolean;
    subPlace: string;
    types: {
      desktop: boolean;
      laptop: boolean;
      mobile: boolean;
      tablet: boolean;
    };
  };
  type: string;
} | null;

export default componentFactory
  .mixin(injectStylesMixin(styles))
  .mixin(tsStoreMixin)
  .create({
    name: 'AdvInread',
    props: {
      adv: {
        type: Object as () => AdvData,
        required: true as const
      },
      index: {
        type: Number,
        default: undefined
      }
    },
    computed: {
      isAdblock() {
        return this.store.isAdblock;
      },
      isThemeWithoutAds() {
        const recordThemes = this.store.layoutModule.record.data.themes;
        const matchedThemes = recordThemes.filter(function (item) {
          return THEMES_WITHOUT_ADS.includes(item.id);
        });

        return matchedThemes.length > 0;
      },
      advData(): string {
        return this.adv?.data || '';
      },
      advHtml(): string {
        let advHtml = '';

        if (this.index) {
          const oldContainerId = tagId(this.advData);

          if (oldContainerId) {
            const regex = new RegExp(oldContainerId, 'g');
            const newContainerId = oldContainerId + '_' + String(this.index);
            advHtml = this.advData.replace(regex, newContainerId) || '';
            return advHtml;
          }
        }

        return this.advData;
      },
      isResponsivePlaceholder(): boolean {
        return this.advData.includes('responsivePlaceholder');
      },
      isRender() {
        if (this.isThemeWithoutAds) {
          return false;
        }

        return true;
      }
    },
    mounted() {
      if (this.$root._isMounted) {
        this.injectAdvScript();
      }
    },
    methods: {
      injectAdvScript(): void {
        const parsedAdv = this.store.advModule.advService.processAdvContent(this.advHtml);
        void this.store.commonModule.externalScriptsService.injectScriptToHead(
          parsedAdv.script
        );
      }
    },
    render() {
      return this.isRender ? (
        <div
          class={[
            styles.adv,
            this.adv?.settings?.types?.desktop ? styles.desktop : '',
            this.adv?.settings?.types?.laptop ? styles.laptop : '',
            this.adv?.settings?.types?.tablet ? styles.tablet : '',
            this.adv?.settings?.types?.mobile ? styles.mobile : '',
            this.isResponsivePlaceholder ? styles.responsivePlaceholder : ''
          ]}
          data-cms-place={this.adv?.settings?.placeId}
        >
          <LazyHydrate ssrOnly={true}>
            <div class={styles.advContent} domPropsInnerHTML={this.advHtml} />
          </LazyHydrate>
        </div>
      ) : (
        <div class={styles.notRender} data-cms-place={this.adv?.settings?.placeId} />
      );
    }
  });
